import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export default function TpmTipsModal({ show, onHide }) {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Maintenance Tier Framework (PCS Counter Trigger)</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p><strong>Tier 0:</strong> Daily or shift routine maintenance performed on-machine without removing the mold.</p>
                <p><strong>Tier A:</strong> Light cleaning, surface inspection, and lubrication performed on-machine.</p>
                <p><strong>Tier B:</strong> The tool is pulled to the toolroom bench for partial disassembly, runner and cooling maintenance, and ejector checks.</p>
                <p className="mb-0"><strong>Tier C:</strong> Full disassembly, deep ultrasonic cleaning, wear-item replacement, and dimensional re-validation.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}
